import React, { useState } from "react";
import { motion } from "framer-motion";
// Update this import to match your actual path:
import ApolloFoundationLogo from "../../assets/img/apollo-opp-foundation.png"
const apolloCitizenshipLogo =
  process.env.PUBLIC_URL + "/images/apollo/apollo-citizenship-logo.png";

const subtleBounceTransition = {
  type: "spring",
  stiffness: 80,
  damping: 18,
};

const headerVariants = {
  initial: { y: -20, opacity: 0 },
  animate: { y: 0, opacity: 1 },
};

const Navbar = ({ currentPage }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => setIsNavOpen((prev) => !prev);

  return (
    <motion.div
      className={`header-bar ${isNavOpen ? "header-bar--open" : ""}`}
      initial="initial"
      animate="animate"
      transition={subtleBounceTransition}
    //   variants={headerVariants}
    >
      <div className="auto__container">
        {/* TOP ROW */}
        <div className="header-top">
          <div className="header-top__left">
            <div className="header-logo-group">
              <a className="header-logo" href="/" aria-label="Go to Apollo Purpose Portal home">
                <img
                  className="img-fluid"
                  src={ApolloFoundationLogo}
                  alt="Apollo Foundation"
                />
              </a>
              <img
                className="header-logo-citizenship"
                src={apolloCitizenshipLogo}
                alt="Apollo Citizenship"
              />
            </div>
          </div>

          <div className="header-top__right">
            {/* Desktop nav */}
<nav className="header-nav header-nav--desktop">
          <a
            href="/"
            className={`header-nav-link ${
              currentPage === "home" ? "is-active" : ""
            }`}
          >
            Home
          </a>
          <a
            href="/about"
            className={`header-nav-link ${
              currentPage === "about" ? "is-active" : ""
            }`}
          >
            About
          </a>
          <a
            href="/news"
            className={`header-nav-link ${
              currentPage === "news" ? "is-active" : ""
            }`}
          >
            News
          </a>
                    <a
            href="/events"
            className={`header-nav-link ${
              currentPage === "events" ? "is-active" : ""
            }`}
          >
            Events
          </a>
          <a
            href="/success-stories"
            className={`header-nav-link ${
              currentPage === "success-stories" ? "is-active" : ""
            }`}
          >
            Success Stories
          </a>
          <a
            href="/portal"
            className={`header-nav-link header-nav-link--portal ${
              currentPage === "portal" ? "is-active" : ""
            }`}
          >
            <span className="header-nav-link__label">Portal</span>
          </a>
        </nav>

            {/* Desktop user */}
            {/* <button
              className="header-user-button header-user-button--desktop"
              type="button"
            >
              <div className="header-user-button__avatar">
                <img src={user.avatarUrl} alt={user.name} />
              </div>
              <div className="header-user-button__text">
                <span className="header-user-button__name">{user.name}</span>
                <span className="header-user-button__role">
                  {user.accountType}
                </span>
              </div>
              <div
                className="header-user-button__notifications"
                aria-label="Notifications"
              >
                {user.hasNotifications && (
                  <span className="header-user-button__notification-dot" />
                )}
              </div>
            </button> */}

            {/* Mobile hamburger */}
            <button
              type="button"
              className="header-burger"
              onClick={toggleNav}
              aria-label={isNavOpen ? "Close navigation" : "Open navigation"}
            >
              <div className="header-burger__lines">
                <span className="header-burger__line header-burger__line--top" />
                <span className="header-burger__line header-burger__line--middle" />
                <span className="header-burger__line header-burger__line--bottom" />
              </div>
            </button>
          </div>
        </div>

        {/* MOBILE DROPDOWN AREA (sits under the top row, in normal flow) */}
        <div className="header-menu">
          <nav className="header-nav header-nav--mobile">
            <a href="/" className="header-nav-link">
              Home
            </a>
            <a href="/about" className="header-nav-link">
              About
            </a>
            <a href="/news" className="header-nav-link">
              News
            </a>
            <a href="/events" className="header-nav-link">
              Events
            </a>
            <a href="/success-stories" className="header-nav-link">
              Success Stories
            </a>
            <a href="/portal" className="header-nav-link header-nav-link--portal">
              <span className="header-nav-link__label">Portal</span>
            </a>
          </nav>

          {/* <button
            className="header-user-button header-user-button--mobile"
            type="button"
          >
            <div className="header-user-button__avatar">
              <img src={user.avatarUrl} alt={user.name} />
            </div>
            <div className="header-user-button__text">
              <span className="header-user-button__name">{user.name}</span>
              <span className="header-user-button__role">
                {user.accountType}
              </span>
            </div>
            <div
              className="header-user-button__notifications"
              aria-label="Notifications"
            >
              {user.hasNotifications && (
                <span className="header-user-button__notification-dot" />
              )}
            </div>
          </button> */}
        </div>
      </div>
    </motion.div>
  );
};

export default Navbar;
